import { render, staticRenderFns } from "./TargetMap.vue?vue&type=template&id=0a804810"
import script from "./TargetMap.vue?vue&type=script&lang=js"
export * from "./TargetMap.vue?vue&type=script&lang=js"
import style0 from "./TargetMap.vue?vue&type=style&index=0&id=0a804810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports